// src/components/SEO.tsx
import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

interface SEOProps {
  title: string;
  description?: string;
  image?: string;
  type?: string;
  siteName?: string;
}

const SEO = ({
  title,
  description = 'Your trusted legal partner for intelligent solutions.',
  image = `${process.env.REACT_APP_BASE_URL}og-image.png`,
  type = 'website',
  siteName = 'Legalligence',
}: SEOProps) => {
  const location = useLocation();
  const currentUrl = `${process.env.REACT_APP_BASE_URL}${location?.pathname?.replace(/^\//, '')}`;

  return (
    <Helmet>
      <title>
        {title} - {siteName}
      </title>
      <meta property="og:title" content={title} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:description" content={description} />
    </Helmet>
  );
};

export default SEO;
